import { IAcompanhamentoStrategy } from "./IAcompanhamentoStrategy.js";
import { listarAutorizacoesDoEstudante } from "../estudanteAcompanhamentoService.js";
import { criarLogger } from "../acompanhamentoHelpers.js";

const logEstudante = criarLogger("Strategy:Estudante");

/**
 * Estratégia especializada para o perfil Estudante / Aprendiz.
 *
 * Princípio da Responsabilidade Única (SRP):
 * Carrega exclusivamente as autorizações vinculadas ao CPF do estudante logado.
 */
export class EstudanteAcompanhamentoStrategy extends IAcompanhamentoStrategy {
  async carregar({ token, signal } = {}) {
    logEstudante("Carregando autorizações do estudante logado...");
    const lista = await listarAutorizacoesDoEstudante(token, signal);
    logEstudante("Autorizações carregadas para estudante:", lista.length);
    return lista;
  }
}
